/**
 * Back-in-stock notify flow.
 *
 * - Watches the product form's selected variant.
 * - When the variant is sold-out, swaps the main ATC button into a
 *   "Notify me when back" button + hides Shop Pay.
 * - On click, opens the modal in pdp-back-in-stock.liquid.
 * - On submit:
 *     1) POST to Klaviyo's client back-in-stock subscription endpoint.
 *     2) Subscribe the email to the configured newsletter list (required by
 *        the checkbox to receive the alert).
 *
 * Set window.__PDP_BIS_DEBUG = true for verbose logging.
 */
(function () {
  const modal = document.querySelector('[data-pdp-bis]');
  if (!modal) return;

  const cfgEl = document.querySelector('[data-pdp-bis-config]');
  if (!cfgEl) return;
  let config = {};
  try { config = JSON.parse(cfgEl.textContent); } catch (e) {}

  const form = document.querySelector('form.product-form');
  if (!form) return;

  const mainAtc = form.querySelector('.product-form__cart-submit') ||
                  form.querySelector('[name="add"]');
  if (!mainAtc) return;

  const originalAtcText = mainAtc.textContent.trim();
  const originalAtcLabel = mainAtc.getAttribute('aria-label');

  function debug() {
    if (window.__PDP_BIS_DEBUG) console.log.apply(console, ['[pdp-bis]'].concat([].slice.call(arguments)));
  }

  function getVariant() {
    const checked = form.querySelector('input[name="id"]:checked');
    const select = form.querySelector('select[name="id"]');
    const hidden = form.querySelector('input[name="id"]');
    const variantId = (checked && checked.value) || (select && select.value) || (hidden && hidden.value);
    if (!variantId) return null;
    if (!window.__rsr_product_data) return null;
    return window.__rsr_product_data.variants.find(function (v) { return String(v.id) === String(variantId); });
  }

  function fetchProductOnce() {
    if (window.__rsr_product_data) return Promise.resolve(window.__rsr_product_data);
    return fetch('/products/' + config.product_handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        window.__rsr_product_data = data;
        return data;
      });
  }

  // FIX (jul 3): write the label via the .js-product-add-text span, never the
  // whole button — button.textContent wipes the span/tick/spinner children that
  // the theme's VariantRadios.toggleAddButton needs ([name="add"] > span), which
  // made it throw and leave stale "Sold out" labels after color switches.
  function atcLabel() {
    return mainAtc.querySelector('.js-product-add-text') || mainAtc;
  }
  function atcWrap() {
    return mainAtc.closest('.js-product-buttons');
  }

  const BIS_TEXT = 'Notify me when back';

  function enforceBisVisual() {
    const l = atcLabel();
    if (l.textContent.trim() !== BIS_TEXT) l.textContent = BIS_TEXT;
    if (mainAtc.getAttribute('type') !== 'button') mainAtc.setAttribute('type', 'button');
    if (!mainAtc.classList.contains('is-bis-mode')) mainAtc.classList.add('is-bis-mode');
    if (mainAtc.hasAttribute('disabled')) mainAtc.removeAttribute('disabled');
    if (mainAtc.classList.contains('is-disabled')) mainAtc.classList.remove('is-disabled');
    const w = atcWrap();
    if (w && w.classList.contains('is-disabled')) w.classList.remove('is-disabled');
  }

  let bisMode = false;
  function applyState() {
    const variant = getVariant();
    if (!variant) return;
    const soldOut = !variant.available;

    if (soldOut && !bisMode) {
      debug('switching ATC to back-in-stock', variant.id);
      mainAtc.dataset.atcOriginalText = atcLabel().textContent.trim();
      bisMode = true;
      enforceBisVisual();
    } else if (!soldOut && bisMode) {
      debug('restoring ATC to add-to-cart', variant.id);
      const restore = (window.theme && window.theme.t && window.theme.t.add_to_cart) ||
                      mainAtc.dataset.atcOriginalText || originalAtcText;
      atcLabel().textContent = restore;
      mainAtc.setAttribute('type', 'submit');
      mainAtc.classList.remove('is-bis-mode');
      bisMode = false;
    }
  }

  // FIX (jul 3): toggleAddButton runs async (section re-render) after variant
  // changes and can re-disable the button / overwrite the label AFTER we've
  // swapped to BIS mode. Watch the button + wrapper and re-apply while in BIS.
  (function () {
    const obs = new MutationObserver(function () { if (bisMode) enforceBisVisual(); });
    const opts = { childList: true, subtree: true, characterData: true,
                   attributes: true, attributeFilter: ['disabled', 'class'] };
    obs.observe(mainAtc, opts);
    const w = atcWrap();
    if (w) obs.observe(w, { attributes: true, attributeFilter: ['class'] });
  })();

  // Discoverability: circled-? next to the Size label explaining the
  // notify-me flow. Hover on desktop; focus/tap on mobile.
  (function () {
    var target = null;
    document.querySelectorAll('fieldset.product-form__swatch legend').forEach(function (legend) {
      if (!target && /size/i.test(legend.textContent)) target = legend;
    });
    if (!target || target.querySelector('.pdp-bis-help')) return;
    var help = document.createElement('span');
    help.className = 'pdp-bis-help';
    help.setAttribute('tabindex', '0');
    help.setAttribute('role', 'button');
    help.setAttribute('aria-label', 'About sold-out sizes');
    help.innerHTML = '?<span class="pdp-bis-help__tip">Sold out in your size or color? Select it anyway and hit \u201cNotify me when back\u201d \u2014 we\u2019ll email you the moment it returns.</span>';
    target.appendChild(help);
  })();

  // Intercept ATC click when in BIS mode
  mainAtc.addEventListener('click', function (e) {
    if (!bisMode) return;
    e.preventDefault();
    e.stopPropagation();
    const variant = getVariant();
    if (!variant) return;
    openModal(variant);
  }, true);

  // Modal open/close
  function openModal(variant) {
    const nameEl = modal.querySelector('[data-pdp-bis-name]');
    if (nameEl) {
      nameEl.textContent = (config.product_title || '') + ' · ' + (variant.title || '');
    }
    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      const input = modal.querySelector('[data-pdp-bis-email]');
      if (input) input.focus();
    });
  }

  function closeModal() {
    modal.classList.remove('is-open');
    setTimeout(function () { modal.hidden = true; }, 200);
  }

  modal.querySelectorAll('[data-pdp-bis-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  // Submit
  const bisForm = modal.querySelector('[data-pdp-bis-form]');
  const submitBtn = modal.querySelector('[data-pdp-bis-submit]');
  const statusEl = modal.querySelector('[data-pdp-bis-status]');

  bisForm.addEventListener('submit', async function (e) {
    e.preventDefault();
    const email = modal.querySelector('[data-pdp-bis-email]').value.trim();
    const newsletter = modal.querySelector('[data-pdp-bis-newsletter]').checked;
    if (!email || !newsletter) {
      showStatus('Please complete both fields.', true);
      return;
    }
    if (!config.klaviyo_public_key) {
      showStatus('Klaviyo not configured. Email: ' + email, true);
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    const variant = getVariant();
    if (!variant) { submitBtn.disabled = false; submitBtn.textContent = 'Notify me when restocked'; return; }

    const promises = [];

    // 1) Back-in-stock subscription (Klaviyo Client API)
    const bisBody = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } }
        }
      }
    };
    promises.push(
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(config.klaviyo_public_key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(bisBody)
      })
    );

    // 2) Newsletter subscription if list configured
    if (config.newsletter_list_id) {
      const subBody = {
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            custom_source: 'PDP back-in-stock'
          },
          relationships: {
            list: { data: { type: 'list', id: config.newsletter_list_id } }
          }
        }
      };
      promises.push(
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.klaviyo_public_key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(subBody)
        })
      );
    }

    try {
      await Promise.all(promises);
      showStatus("You're on the list. We'll email you when this is back.", false);
      setTimeout(closeModal, 1800);
    } catch (err) {
      debug('error', err);
      showStatus('Something went wrong. Please try again.', true);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Notify me when restocked';
    }
  });

  function showStatus(msg, isError) {
    if (!statusEl) return;
    statusEl.textContent = msg;
    statusEl.hidden = false;
    statusEl.style.color = isError ? '#A32D2D' : '#1a1310';
  }

  // Poll variant changes
  let last = null;
  setInterval(function () {
    const checked = form.querySelector('input[name="id"]:checked');
    const select = form.querySelector('select[name="id"]');
    const hidden = form.querySelector('input[name="id"]');
    const variantId = (checked && checked.value) || (select && select.value) || (hidden && hidden.value);
    if (variantId && variantId !== last) {
      last = variantId;
      fetchProductOnce().then(applyState).catch(function () {});
    }
  }, 200);

  fetchProductOnce().then(applyState).catch(function () {});
})();
